// extracted by mini-css-extract-plugin
module.exports = {"page":"jgp-2_VKG"};